"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identity = exports.error = exports.warn = exports.trace = exports.noop = exports.once = exports.pipe = exports.compose = exports.callAll = exports.callAllHandlers = exports.runIfFn = void 0;
const assertion_1 = require("./assertion");
const runIfFn = (valueOrFn, ...args) => (0, assertion_1.isFunction)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
exports.runIfFn = runIfFn;
const callAllHandlers = (...fns) => (event) => fns.some(fn => {
    fn === null || fn === void 0 ? void 0 : fn(event);
    return event === null || event === void 0 ? void 0 : event.defaultPrevented;
});
exports.callAllHandlers = callAllHandlers;
function callAll(...fns) {
    return function mergedFn(arg) {
        fns.forEach(fn => {
            fn === null || fn === void 0 ? void 0 : fn(arg);
        });
    };
}
exports.callAll = callAll;
const compose = (fn1, ...fns) => fns.reduce((f1, f2) => (...args) => f1(f2(...args)), fn1);
exports.compose = compose;
const pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
exports.pipe = pipe;
function once(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
exports.once = once;
const noop = () => undefined;
exports.noop = noop;
const trace = (label) => (x) => {
    if (assertion_1.__DEV__)
        console.log(label, x);
    return x;
};
exports.trace = trace;
exports.warn = once((options) => () => {
    const { condition, message } = options;
    if (condition && assertion_1.__DEV__) {
        console.warn(message);
    }
});
exports.error = once((options) => () => {
    const { condition, message } = options;
    if (condition && assertion_1.__DEV__) {
        console.error(message);
    }
});
const identity = (x) => x;
exports.identity = identity;
//# sourceMappingURL=function.js.map